import { default as WJElement } from '../wje-element/element.js';
import CardHeader from './card-header.element.js';

// export * from "./card-header.element.js";
export default CardHeader;

WJElement.define('wje-card-header', CardHeader);
